import { isRelativeUrl } from 'common/link/link-utils';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMarkerVersionLinkUrl, IMarker } from 'types/markerCore/marker-core-type';
import { trackNavigateEvent } from 'utilities/posthog-tracking';
import { getWindow } from 'utilities/window';

export const UseUpdateLocation = () => {
  const navigate = useNavigate();

  const onClick = useCallback(
    (marker?: IMarker) => {
      const url = getMarkerVersionLinkUrl(marker);
      if (url) {
        trackNavigateEvent('map', 'location_pill');
        if (isRelativeUrl(false, url)) {
          navigate(url);
        } else {
          getWindow()?.open(url, '_blank');
        }
      }
    },
    [navigate],
  );

  return { onClick };
};
